// Mirrors backend/src/utils/billingAddress.js's getBillingAddress — resolves the address
// to show/use for billing purposes: the explicit billingAddress override when set, else the
// installation address. area/landmark/coordinates aren't modeled on billingAddress, so those
// always come from the installation address.
export function getBillingAddress(customer) {
  const ba = customer?.billingAddress || {};
  const addr = customer?.address || {};
  const useBilling = ba.sameAsInstallation === false && (ba.line1 || ba.city);
  return {
    line1: (useBilling ? ba.line1 : addr.line1) || '',
    line2: (useBilling ? ba.line2 : addr.line2) || '',
    city: (useBilling ? ba.city : addr.city) || '',
    pincode: (useBilling ? ba.pincode : addr.pincode) || '',
    area: addr.area || '',
    landmark: addr.landmark || '',
  };
}
